import React, { useState, useMemo, useCallback, useRef } from 'react';
import { getNumComparators, getDateComparators, getTextComparators } from '../../library/comparators';
import { fileSizeFormatter } from '../../library/formatters';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { BatchActionAccordion } from '../BatchActionAccordion';
import { BatchFileActions } from './FileActions';
import { FileActions } from './FileActions';
import { UpdateService } from '../../services/UpdateService';
import { FilesTable } from './FilesTable';

import { CustomStateFilter } from '../Table/CustomFilters/CustomStateFilter';
import { SaveTableSettings } from '../Table/SaveTableSettings';
import { dateFormatter, dateTimeFormatter } from '../../library/formatters';
import { CustomStateCell } from '../Table/CustomStateCell';
import { NameTableCellLink } from '../Table/IdTableCellLink';


export const ModFileTable =({fileTableId, getRows, additionalColumns, addButtonConfiguration, tableSize='', columnConfiguration = { xs: 12, sm: 12, md: 12, lg: 12}, pageSizeOptions=[15, 25, 50, 100], handleRowSelect=null, active=true, isJobRunning = true, isLoading = false}) =>
{
  
  const gridRef = useRef();
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [gridParams, setGridParams] = useState(null);

  const defaultPageSize = 25;
  const gridId = `${fileTableId}-fileGrid`;

  const numComparators = getNumComparators();
  const dateComparators = getDateComparators();
  const textComparators = getTextComparators();

  const stateMessageGetter = (params) => {
    return params?.data?.stateMessage == null || params?.data?.stateMessage === "" ? '- No Status Message -' : params.data.stateMessage;
  }

  const stateOptions = ["Evicted", 'Failed', 'InProgress', 'Pending', "Purging", 'Ready', 'Unknown'];
  
  
  const [colDefs, setColDefs] = useState([
    
    {field: "fileName", headerName: "File Name", filter: 'agTextColumnFilter', sortable: true, filterParams:{buttons: ["clear"], filterOptions: textComparators, maxNumConditions: 1}, cellRenderer: NameTableCellLink, cellRendererParams:{ gridRef: gridRef, path: "/files/"}, flex:1, tooltipField: "fileName"},
    {field: "fileSize", filter: 'agNumberColumnFilter', filterParams:{buttons: ["clear"], filterOptions : numComparators, maxNumConditions: 1}, valueFormatter: fileSizeFormatter, flex:1, sortable: true},
    {field: "status",filter: CustomStateFilter, cellRenderer: CustomStateCell, sortable: false, cellRendererParams: { gridRef: gridRef},filterParams:{buttons: ["clear"],filterOptions : stateOptions }, flex:1, tooltipValueGetter: stateMessageGetter},
    {field: "created", filter: 'agDateColumnFilter', 
          sortable: true, valueFormatter: dateTimeFormatter, 
          filterParams:{buttons: ["clear"],filterOptions : dateComparators, maxNumConditions: 1, maxValidYear:9999},flex:1, 
        },
    ...additionalColumns,
    {field: "actions", editable: false, filter: false,  headerName: "Actions", sortable: false, cellRenderer: FileActions, cellRendererParams: { gridRef: gridRef, disableButtons: addButtonConfiguration.disableAdd, setErrorMessage:setErrorMessage}, flex:1},
  ]);

  const refreshTable = () => {
    gridRef.current.api.refreshInfiniteCache();
  }
      
  const rowSelectionChanged = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    
    if(handleRowSelect != null)
    {
      handleRowSelect(selectedRows);
    }
    if(selectedRows.length > 0)
    {
      setOpen(true);
    }
    else
    {
      setOpen(false);
    }
    
  },[]);
  

  const onGridReady = useCallback( async (params) => {
    setGridParams(params);
    const dataSource = {
      rowCount: undefined,
      getRows: getRows
    };
    params.api.setGridOption('datasource', dataSource);
    
  });

  const fileTableConfiguration = {
    gridId: gridId,
    defaultPageSize: defaultPageSize,
    pageSizeOptions: pageSizeOptions,
    colDefs: colDefs,
    onGridReady: onGridReady,
    rowSelectionChanged: rowSelectionChanged,
    gridRef: gridRef,
  }
  
  return<>
  {
    errorMessage.show && <Alert variant={errorMessage.status} onClose={() => setErrorMessage(false)} dismissible>{errorMessage.message}</Alert>
  }

    <Col xs={12-columnConfiguration.xs} sm={12-columnConfiguration.sm} md={12-columnConfiguration.md} lg={12-columnConfiguration.lg} style={{display:isLoading && 'none'}}>
      <div className="bottom-right-container">
        <BatchActionAccordion open={open} batchAction={<BatchFileActions gridRef={gridRef} setErrorMessage={setErrorMessage}/>}/>
        <SaveTableSettings gridParams={gridParams} gridRef={gridRef} tableType={fileTableId}/>
      </div>
    </Col>
  
  <Row style={{display:isLoading && 'none'}}>
    <FilesTable tableSize={tableSize} fileTableConfiguration={fileTableConfiguration}/>
    <UpdateService updateDataFunction={refreshTable} gridRef={gridRef} active={active} isJobRunning={isJobRunning}/>   
  </Row>
  </>
}